// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@4.3.0_webpack@5.104.1_webpack-cli@6.0.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-bar {\n  margin-bottom: 24px;\n}\n.search-bar .top-row {\n  display: flex;\n  flex: 1 1 100%;\n}\n.search-bar .bottom-row {\n  margin-top: 12px;\n}\n.yellow {\n  background-color: yellow;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
